import { Map } from "mapbox-gl";
import { getSteps } from "./steps";
import { MOBILE_WIDTH } from "./config";

export function getResponsiveZoom(baseZoom: number): number {
  const isMobile = window.innerWidth <= MOBILE_WIDTH;
  return isMobile ? baseZoom - 1.5 : baseZoom;
}

export const responsiveZoomLevels = {
  step0: (): number => getResponsiveZoom(15),
  step1: (): number => getResponsiveZoom(10.5),
  step2: (): number => getResponsiveZoom(10.5),
  step3: (): number => getResponsiveZoom(10.5),
  step4: (): number => getResponsiveZoom(9.75)
};

export function updateMapZoomOnResize(
  map: Map,
  currentStep: number,
  windowWidth: number
): void {
  const steps = getSteps(windowWidth);
  const stepConfig = steps[currentStep];

  if (stepConfig) {
    map.setZoom(stepConfig.zoom);
    return;
  }
}
